import React from "react";
import { SVG, IconProps } from "../SVG";

export const HospitalSimple = ({
    color = "currentColor",
    strokeWidth = 1.5,
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 16" {...props}>
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={strokeWidth}
            d="M1.083 14.285h2.089m9.745 0H10.83m-7.658 0V3.182c0-.81.66-1.468 1.47-1.468h4.718c.81 0 1.47.659 1.47 1.468V14.285m-7.658 0H5.84m4.989 0H8.16m-2.32 0h2.32m-2.32 0v-3.411h2.32v3.411M7 7.5V6m0 0V4.5M7 6H5.5M7 6H8.5"
        />
    </SVG>
);

HospitalSimple.displayName = "HospitalSimple";
